query MfaSessionDetails($runId: ConditionID!) {
	mfa_session_runs(run_id_eq: $runId) {
		run_id
		session_name
		run_time
		run_updated_at
		user_name
		custom_fields
		app
		app_version
	}
}
